import { baseURL } from "../API/API";

export function getApiOrigin() {
  try {
    return baseURL.replace(/\/api\/?$/, "");
  } catch {
    return "https://api.nouhacadeemy.com";
  }
}

export function resolveMediaUrl(path) {
  if (!path || typeof path !== "string") return null;

  const trimmed = path.trim();
  if (!trimmed) return null;

  const origin = getApiOrigin();

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const urlObj = new URL(trimmed);
      if (urlObj.pathname.includes("/storage/")) {
        return `${origin}${urlObj.pathname}${urlObj.search}${urlObj.hash}`;
      }
    } catch {
      return trimmed;
    }
    return trimmed;
  }

  let pathPart = trimmed.replace(/\\/g, "/");
  const publicStorageIndex = pathPart.indexOf("public/storage/");
  const storageIndex = pathPart.indexOf("storage/");

  if (publicStorageIndex !== -1) {
    pathPart = "/" + pathPart.substring(publicStorageIndex + "public/".length);
  } else if (storageIndex !== -1) {
    pathPart = "/" + pathPart.substring(storageIndex);
  } else if (!pathPart.startsWith("/")) {
    pathPart = `/storage/${pathPart}`;
  }

  return `${origin}${pathPart}`;
}